import React from 'react';
import PropTypes from 'prop-types';
import { Loader, Button } from 'kangarootime-ui';
import { Fade } from '@material-ui/core';
import './MonthYearPhotoGrid.css';
import MonthPhotoGroup from './MonthPhotoGroup';

const MonthYearPhotoGrid = ({
  fetchingMore,
  photosByMonth,
  loadMorePhotos,
  selectPhoto,
  onScroll,
  ...props
}) => {
  // show a load more button if there are less than three months fetched
  // if the initial fetch is empty or months only have a couple of photos, you can't scroll to load more

  return (
    <Fade in>
      <div className='flex-columns month-year-grid-container' onScroll={onScroll}>
        { Object.keys(photosByMonth).map(key => {
          const value = photosByMonth[key];
          const [year, month] = key.split('-');

          return (
            <MonthPhotoGroup
              key={`photo-group-${year}-${month}`}
              month={month}
              year={year}
              photos={value}
              selectPhoto={selectPhoto}
            />
          );
        })}
        <Loader loading={fetchingMore}>
          <Button onClick={loadMorePhotos} style={{ alignSelf: 'center', marginTop: 16 }}>Load More</Button>
        </Loader>
      </div>
    </Fade>
  );
};

MonthYearPhotoGrid.propTypes = {
  fetchingMore: PropTypes.bool,
  photosByMonth: PropTypes.object,
  loadMorePhotos: PropTypes.func,
  selectPhoto: PropTypes.func,
  onScroll: PropTypes.func
};

MonthYearPhotoGrid.defaultProps = {
  photosByMonth: {}
};

export default MonthYearPhotoGrid;
